import { html, LitElement } from 'lit';
import Styles from './vm-video-chapter.scss';

export default class VmVideoChapter extends LitElement {
    static styles = Styles;

    static properties = {
        thumbnailSrc: { type: String },
        timestampStart: { type: Number },
        timestampEnd: { type: Number },
        ordinalNumber: { type: Number },
        title: { type: String },
    };

    connectedCallback() {
        super.connectedCallback();

        this.setAttribute('role', 'listitem');
    }

    get duration() {
        const durationMs = this.timestampEnd - this.timestampStart;
        const totalSeconds = Math.round(durationMs / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        return `${minutes > 0 ? minutes + 'm ' : ''}${seconds > 0 ? seconds + 's' : ''}`.trim();
    }

    render() {
        return html`
            <div class="video-chapter-preview">
                <img class="video-chapter-preview__thumbnail" src="${this.thumbnailSrc}" alt="${this.title}" />
                <div class="video-chapter-preview__duration">${this.duration}</div>
            </div>
            <div class="video-chapter-title" data-testid="video-chapter-title">
                <span class="video-chapter-title__ordinal">${this.ordinalNumber}.</span>
                ${this.title}
            </div>
        `;
    }
}

customElements.define('vm-video-chapter', VmVideoChapter);
